import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "app/constants";
import { FaqsModel, FaqsPaginated } from "app/faqs/faqs-model";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class FaqsService {
    constructor(private http: HttpClient) { }

    getFaqs() {}

    getFaqsPaginated(url: string): Observable<FaqsPaginated> {
        return this.http.get<FaqsPaginated>(environment.apiUrl+url);
    }

    deleteFaq(id: string) {
        return this.http.delete(environment.apiUrl+'FrequentlyAskedQuestions/delete/'+id);
    }

    getFaqById(id: string): Observable<FaqsModel> {
        return this.http.get<FaqsModel>(environment.apiUrl+'FrequentlyAskedQuestions/getById/'+id);
    }

    addFaqs(data: FaqsModel): Observable<FaqsPaginated> {
        return this.http.post<FaqsPaginated>(environment.apiUrl+'FrequentlyAskedQuestions/create/', data);
    }

    updateFaqs(data: FaqsModel): Observable<FaqsPaginated> {
        return this.http.post<FaqsPaginated>(environment.apiUrl+'FrequentlyAskedQuestions/update/'+data.id, data);
    }
}
